module.exports = __webpack_public_path__ + "img/bg.58a59aa0.jpg";